import React, { Component } from "react";
import { connect } from "react-redux";
import { Dimmer, Loader } from "semantic-ui-react";
import PropTypes from "prop-types";
import { createAndGoToParty } from "../VotifyParty/partyActionCreators";
import { handleRouteError } from "../../Util/utilActionCreators";
import {
  getPrivateCredentials,
  saveSimpleToken,
} from "../VotifyHost/hostActionCreators";
import { getParamPairs } from "../../../utils/utils";

class AuthenticationCallbackHandler extends Component {
  componentDidMount() {
    console.log("AuthenticationCallbackHandler");
    console.log(this.props);
    try {
      const path = this.props.location.search;
      const jwtToken = getParamPairs(path)["jwt"];
      this.props.saveSimpleToken(jwtToken);
      this.props.getPrivateCredentials(jwtToken);
      this.props.createAndGoToParty();
    } catch (error) {
      this.props.handleRouteError();
    }
  }

  render() {
    return (
      <Dimmer active>
        <Loader size="massive" />
      </Dimmer>
    );
  }
}

AuthenticationCallbackHandler.propTypes = {
  createAndGoToParty: PropTypes.func.isRequired,
  handleRouteError: PropTypes.func.isRequired,
  saveSimpleToken: PropTypes.func.isRequired,
  getPrivateCredentials: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
  console.log("ownProps");
  console.log(ownProps);
  return {
    createAndGoToParty: () => dispatch(createAndGoToParty(ownProps.history)),
    handleRouteError: () => dispatch(handleRouteError(ownProps.history)),
    saveSimpleToken: (jwtToken) => dispatch(saveSimpleToken(jwtToken)),
    getPrivateCredentials: (jwtToken) =>
      dispatch(getPrivateCredentials(jwtToken)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AuthenticationCallbackHandler);
